module.exports = __webpack_public_path__ + "static/img/49-1.fcd211e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/49-1.jpg
// module id = iRMM
// module chunks = 0